const { init } = require("aos");
const { speed } = require("jquery");

;(function ($) {

	'use strict';

	var swiperAlbion = new Swiper(".swiper--albion", {
		spaceBetween: 30,
		// effect: "fade",
		loop: true,
		// autoplay: {
		// 	delay: 2500,
		// 	disableOnInteraction: false,
		// },
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
	});

	var playPauseBtn = document.querySelector('.swiper--albion .playPauseBtn');
	if (playPauseBtn) {

		var svgPlay = playPauseBtn.querySelector('svg:nth-child(2)');
		var svgPause = playPauseBtn.querySelector('svg:nth-child(1)');
	
		/** Pomocná funkce pro zjištění videa na aktivním slajdu */
		function getActiveVideo() {
				const activeSlide = swiperAlbion.slides[swiperAlbion.activeIndex];
				return activeSlide ? activeSlide.querySelector('video') : null;
		}
	
		/** Aktualizace tlačítka a zobrazení podle aktivního slajdu */
		function updateControls() {
				const video = getActiveVideo();
	
				if (video) {
						playPauseBtn.style.opacity = '1'; // zobrazit
						// změna ikony podle stavu
						if (video.paused) {
								svgPlay.style.display = 'block';
								svgPause.style.display = 'none';
						} else {
								svgPlay.style.display = 'none';
								svgPause.style.display = 'block';
						}
				} else {
						playPauseBtn.style.opacity = '0'; // skrýt, pokud není video
				}
		}
	
		/** Přehrát video na aktuálním slajdu a pauznout ostatní */
		function handleSlideChange() {
				swiperAlbion.slides.forEach(slide => {
						const vid = slide.querySelector('video');
						if (vid) {
								vid.pause();
								vid.currentTime = 0; // volitelné – reset na začátek
						}
				});
	
				const currentVideo = getActiveVideo();
				if (currentVideo) {
						currentVideo.play().catch(() => {});
				}
	
				updateControls();
		}
	
		// Inicializace po nahrání
		handleSlideChange();
	
		// Při změně slajdu
		swiperAlbion.on('slideChange', handleSlideChange);
	
		// Ovládání tlačítkem Play/Pause
		playPauseBtn.addEventListener('click', () => {

			// přidáme třídu pro animaci
			playPauseBtn.classList.add('animate');

			// po skončení animace třídu odstraníme
			playPauseBtn.addEventListener('animationend', () => {
				playPauseBtn.classList.remove('animate');
			}, { once: true });

				const video = getActiveVideo();
				if (!video) return;
	
				if (video.paused) {
						video.play();
				} else {
						video.pause();
				}
	
				updateControls();
		});
	}

	var swiperAlbionModels1 = new Swiper(".swiper--albion-models-1", {
		spaceBetween: 5,
		// effect: "fade",		
		loop: true,
		speed: 750,
		// autoplay: {
		// 	delay: 2500,
		// 	disableOnInteraction: false,
		// },
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},		
		breakpoints: {
			576: {
				spaceBetween: 75,
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
			},
		},
	});

	var swiperAlbionModels2 = new Swiper(".swiper--albion-models-2", {
		spaceBetween: 5,
		// effect: "fade",		
		loop: true,		
		speed: 750,		
		slidesPerView: 1.075,
		centeredSlides: true,
		// autoplay: {
		// 	delay: 2500,
		// 	disableOnInteraction: false,
		// },
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},		
		breakpoints: {
			576: {
				slidesPerView: 1.35,
				spaceBetween: 30,
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
			},
		},
	});

	// const playPauseBtn = document.getElementById("playPauseBtn");
	// if (playPauseBtn) {

	// 	let isPlaying = true;
	// 	playPauseBtn.addEventListener("click", () => {
	// 		if (isPlaying) {
	// 			swiperAlbion.autoplay.stop();
	// 			alert('stop');
	// 			// playPauseBtn.textContent = "▶️ Play";
	// 		} else {
	// 			swiperAlbion.autoplay.start();
	// 			alert('play');
	// 			// playPauseBtn.textContent = "⏸ Pause";
	// 		}
	// 		isPlaying = !isPlaying;
	// 	});

	// }


	// bootstrap - open all accordion items
	// const toggleBtn = document.getElementById('toggleAll');
  // let allOpen = false;
  // toggleBtn.addEventListener('click', () => {
  //   const collapses = document.querySelectorAll('.accordion .accordion-collapse');
  //   collapses.forEach(collapse => {
  //     if (allOpen) {
  //       bootstrap.Collapse.getOrCreateInstance(collapse).hide();
  //     } else {
  //       bootstrap.Collapse.getOrCreateInstance(collapse).show();
  //     }
  //   });
  //   allOpen = !allOpen;
  //   toggleBtn.textContent = allOpen ? 'Zavřít všechny' : 'Otevřít všechny';
  // });

	$('.accordion__toggleAll').on('click', function () {
		
		let $this = $(this);
		let $items = $this.closest('.accordion').find('.collapse');
		
		if($this.hasClass('opened')) {			
			$items.each(function(){
				new bootstrap.Collapse(this, {toggle: false }).hide();
				$this.find('.accordion-button').addClass('collapsed');
			});
		}
		else {
			$items.each(function(){
				new bootstrap.Collapse(this, {toggle: false }).show();
				$this.find('.accordion-button').removeClass('collapsed');
			});
		}

		
		$this.find('.openText').toggleClass('d-none');
		$this.find('.closeText').toggleClass('d-none');
		$this.toggleClass('opened');

	});

	// toggle parameters on car card
	$('.card__parameters-toggle').on('click', function (e) {

		let $this = $(this);
		let $card = $this.closest('.card');
		let $hidden = $card.find('.card__parameters-hidden');

		$hidden.toggleClass('d-none');
		$this.find('.underline span').toggleClass('d-none');
	});

	// Menu
	var menuButton = $('#menuButtonAlbion');
	if (menuButton.length) {
			menuButton.on('click', function(e) {
					e.preventDefault();
					menuButton.toggleClass('is-active');
					$('body').toggleClass('menu-active');
			});
	}

	// modelCard - play on hover
	// Vybereme všechny modelCard elementy
	const modelCards = document.querySelectorAll('.modelCard');
	modelCards.forEach(card => {
			const video = card.querySelector('video');

			// Pokud video existuje, přidáme posluchače událostí
			if (video) {
					card.addEventListener('mouseenter', () => {
							video.play();
							card.classList.add('active');

							// Přidáme .dimmed na ostatní karty
							modelCards.forEach(otherCard => {
									if (otherCard !== card) {
											otherCard.classList.add('dimmed');
									}
							});
					});

					card.addEventListener('mouseleave', () => {
							video.pause();
							card.classList.remove('active');

							// Odebereme .dimmed ze všech
							modelCards.forEach(otherCard => {
									otherCard.classList.remove('dimmed');
							});
					});
			}
	});

	// $('.playPauseBtn').on('click', function(e) {
	// 	$(this).toggleClass('active');
	// });


	// Toggle submenu
	$('.toggleSubmenu').on('click', function(e) {
		e.preventDefault();
		let targetSelector = $(this).data('toggle');
		let $target = $(targetSelector);
		$target.toggleClass('show');
		$(this).toggleClass('active');
	});


	// Automatické přehrávání/pauza videí ve viewportu
	const videos = document.querySelectorAll('.videoWrapper video');

    // Funkce na přepnutí ikon podle stavu videa
    function updateIcons(video, isPlaying) {
        const wrapper = video.closest('.videoWrapper');
        const btn = wrapper.querySelector('.playPauseBtn');
        const iconPause = btn.querySelector('svg:nth-of-type(1)');
        const iconPlay = btn.querySelector('svg:nth-of-type(2)');

        if (isPlaying) {
            iconPlay.style.display = 'none';
            iconPause.style.display = 'block';
        } else {
            iconPlay.style.display = 'block';
            iconPause.style.display = 'none';
        }
    }

    // Observer sleduje, jestli je video ve viewportu
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const video = entry.target;

            if (entry.isIntersecting) {
                video.play();
                updateIcons(video, true);
            } else {
                video.pause();
                updateIcons(video, false);
            }
        });
    }, {
        threshold: 0.5 // aspoň 50 % videa musí být vidět
    });

    videos.forEach(video => {
        observer.observe(video);

        // Inicializace
        updateIcons(video, true);

        // Reakce na kliknutí na tlačítko
        const wrapper = video.closest('.videoWrapper');
        const btn = wrapper.querySelector('.playPauseBtn');

        btn.addEventListener('click', () => {

					// přidáme třídu pro animaci
    			btn.classList.add('animate');

					// po skončení animace třídu odstraníme
					btn.addEventListener('animationend', () => {
						btn.classList.remove('animate');
					}, { once: true });

					if (video.paused) {
							video.play();
							updateIcons(video, true);
					} else {
							video.pause();
							updateIcons(video, false);
					}

        });

        // Pokud video skončí (pokud by nebylo v loopu)
        video.addEventListener('ended', () => {
            updateIcons(video, false);
        });
    });

		// carousel team service page
		var swiperTeamCarousel = new Swiper(".swiper--team", {
			slidesPerView: 'auto',
			spaceBetween: 24,
			freeMode: true,						
			breakpoints: {
				576: {
					
				},
			},
		});


	
})(jQuery);